import React from 'react';
import { getCheckout } from "../../../data/loca/sumup";
import { Button } from 'primereact/button';

import {
    useLoaderData
} from "react-router-dom";


export async function loader({ params }) {
    var Status = 200;
    var Message = "";


    let ret = await getCheckout(params.id);
    Status = ret.status;
    Message = ret.message;
    var PublicRentalId = ret.publicRentalId;
    var RequiresElectronicSignature = ret.requiresElectronicSignature ?? ret.RequiresElectronicSignature;
    return { Status, Message, PublicRentalId, RequiresElectronicSignature };
}

export default function SumUpPaymentSuccess() {
    const { Status, Message, PublicRentalId, RequiresElectronicSignature } = useLoaderData();

    const redirectToPayment = (rental) => {

        setTimeout(() => {
            let link = `/malocation/${rental}`

            window.location.href = link;
        }, 2000);

    }

    return (
        <div className="endPayment">
            <div id="thumbnail">


                <div className="depositSuccess">
                    {(Status === 200) ? (
                        <>
                            <i className="pi pi-check-circle" style={{ fontSize: '5rem' }}></i>

                            <h2>Le paiement a été effectué avec succès ! Le loueur en a été informé.</h2>
                            {RequiresElectronicSignature && (
                                <p>Signature électronique nécessaire pour finaliser la location.</p>
                            )}
                            <Button size="small" label="Je retourne sur ma page de location" icon="pi pi-replay" onClick={() => redirectToPayment(PublicRentalId)} />

                        </>

                    ) : (
                            <>
                                <i className="pi pi-times-circle" style={{ fontSize: '5rem' }}></i>
                                <br />
                            <h2>{Message}</h2>
                            </>

                    ) }
                 
                </div>
                

            </div>

        </div>
        
    )            
}
